import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AddReaction from './icon-add-reaction.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AddReaction {...validProps} />;
}
SvgComponent.iconName = 'addReaction';

/**
 * @deprecated This is a legacy icon
 */
export const AddReactionIcon = svgIconWrapper(SvgComponent);
